import React from 'react'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'
import usePrevNextBroadcastList from 'core/hooks/usePrevNextBroadcastList'
import { MORE_BROADCAST_LIST_INDEX } from 'core/store/broadcastTable'
import BroadcastCard from './BroadcastCard'
import { useTranslation } from 'react-i18next'

const PrevNextBroadcastList: React.FC = () => {
  const [moreListIndex, setMoreListIndex] = useRecoilState(MORE_BROADCAST_LIST_INDEX)
  const { fromNow } = usePrevNextBroadcastList()
  const { t } = useTranslation()

  /**
   * moreListIndex가 1보다 클 경우 즉, 오늘 이후의 방송 개수가 4개 초과일 경우 true
   */
  const isShowMoreList = moreListIndex > 1

  /**
   * 더보기 버튼 클릭 핸들러
   *
   * 더보기 버튼 클릭 시 moreListIndex가 1씩 감소
   */
  const handleClickMoreButton = () => {
    setMoreListIndex((prev) => prev - 1)
  }

  return (
    <StyledBroadcastCardWrapper>
      {/* 
        - moreListIndex 만큼 fromNow 방송 목록 출력
        - fromNow 배열 길이 - moreListIndex + 1 로 계산
      */}
      {fromNow.slice(0, fromNow.length - moreListIndex + 1).map((data) => {
        return data.map((item) => <BroadcastCard key={item.broadcastName} item={item} />)
      })}
      {isShowMoreList && <StyledButton onClick={handleClickMoreButton}>{t('more')}</StyledButton>}
    </StyledBroadcastCardWrapper>
  )
}

const StyledBroadcastCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const StyledButton = styled.button<{ isShowPrevList?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 10px 10px 14px;
  border-radius: 100px;
  border: 1px solid #e6e6e6;
  background: #fff;
  appearance: none;
  outline: none;
  color: #000;
  font-size: 16px;
  font-weight: 700;
  line-height: 125%; /* 20px */
  cursor: pointer;
  gap: 8px;
  ${({ isShowPrevList }) => isShowPrevList && `svg { transform: rotate(180deg); }`}

  @media screen and (max-width:360px) {
    max-width: 260px;
  }
`

export default PrevNextBroadcastList
